"use strict";
/* globals module */
/**
 * @module calendarACLClient
 * @description  Calendar ACL Client provides an easy way to consume Calendar REST API end-points. In order to obtain a needed routes `calendarACLClient` uses `calendarACLRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../httpApi");
var __1 = require("../");
var CalendarACLClient = /** @class */ (function () {
    function CalendarACLClient(calendarACLRoute, apiClient) {
        this.calendarACLRoute = calendarACLRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarACLClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a list of ACL policies established for the specified calendar resource.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarClient.get({id: '<id>'})
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarACLClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update acl action has been performed, this action creates new ACL policy for the specified calendar resource.
     * @method
     * @param options ACL options object.
     * @example let options = {id : '<id>'};
                let aclObj =  {  actionId: '<action-id'>,  roleId: '<roleId>',  userId: '<userId>' };
                options[baasicConstants.modelPropertyName] = aclObj;
                calendarACLClient.update(options)
                .then(function (data) {
                    // perform success action here
                },
                    function (response, status, headers, config) {
                        // perform error handling here
                });
     */
    CalendarACLClient.prototype.update = function (options) {
        return this.apiClient.put(this.routeDefinition.update(options), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the removeByUser action has been performed. This action deletes ACL policy assigned to the specified user and calendar resource.
     * @method
     * @param id User calendar data id which uniquely identifies user calendar data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user calendar data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @returns A promise that is resolved once the removeByUser action has been performed.
     * @example calendarACLClient.removeByUser('<id>', '<access-action>', '<username>')
                .then(function (data) {
                    // perform success action here
                },
                    function (response, status, headers, config) {
                        // perform error handling here
                });
     */
    CalendarACLClient.prototype.removeByUser = function (id, action, user, data) {
        return this.apiClient.delete(this.calendarACLRoute.deleteByUser(id, action, user, data));
    };
    /**
     * Returns a promise that is resolved once the removeByRole action has been performed. This action deletes ACL policy assigned to the specified role and calendar resource.
     * @method
     * @param id User calendar data id which uniquely identifies user calendar data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user calendar data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @returns A promise that is resolved once the removeByRole action has been performed.
     * @example calendarACLClient.removeByRole('<id>', '<access-action>', '<role-name>')
                .then(function (data) {
                    // perform success action here
                },
                    function (response, status, headers, config) {
                        // perform error handling here
                });
     */
    CalendarACLClient.prototype.removeByRole = function (id, action, role, data) {
        return this.apiClient.delete(this.calendarACLRoute.deleteByRole(id, action, role, data));
    };
    var _a, _b;
    CalendarACLClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarACLRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarACLRoute !== "undefined" && __1.CalendarACLRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarACLClient);
    return CalendarACLClient;
}());
exports.CalendarACLClient = CalendarACLClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
